import convertCentsToDollars from './convert-cents-to-dollars';
import toCurrency from './toCurrency';

const toCurrencyFromCents = (number, showDecimals = true) =>
  toCurrency(convertCentsToDollars(number), showDecimals);

export default toCurrencyFromCents;
